module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign_5.6be13ab7.svg";